import Digits from "@casino/legacy/client/hooks/currency/helpers/Digits";
import useCurrencyConfig from "@casino/legacy/client/hooks/currency/useCurrencyConfig";

const useCurrencyDigits = () => {
  const config = useCurrencyConfig();
  return {
    min: Digits.MINIMUM,
    max: config.maximumFractionDigits ?? Digits.MAXIMUM,
  };
};

export default useCurrencyDigits;
